<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.prevent="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>다른 판매 채널 주문건 엑셀 발송</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="close">닫기</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text class="mt-6 pt-0 pl-6">
          <v-row class="mb-1 col-8 pl-0">
            <v-col class="d-inline-block pl-0 pr-0" cols="7" height="50px">
              <v-file-input
                chips
                label="클릭하여 엑셀 파일을 업로드해주세요."
                class="pt-1 pl-1"
                v-model="excelFile"
                accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              ></v-file-input>
            </v-col>
            <v-col class="d-inline-block pl-0" height="50px">
              <v-btn depressed color="black white--text ml-5" large :loading="uploading" @click.prevent="execExcelUpload">업로드하기</v-btn>
            </v-col>
          </v-row>

          <div>
            <p class="mb-0 body-2 font-weight-light mt-1 black--text">최대 입력 수는 10,000개 입니다.</p>
            <p class="mb-0 body-2 font-weight-light black--text">
              주문상태 (배송완료 or 구매확정) 발송 사용 및 메시지 설정을 해주셔야 정상 발송됩니다.
            </p>
            <p class="mb-0 body-2 font-weight-light black--text">
              ※ 엑셀 파일의 형식은 .xls .xlsx / 파일 용량은 최대 10MB - 큰 용량일 경우 나누어 업로드합니다.
            </p>
          </div>

          <v-btn depressed color="teal" class="mt-3 white--text mb-0" @click.prevent="excelSampleDownLoad">
            엑셀업로드 양식 다운로드
          </v-btn>

          <div class="col-12 pl-0 pb-0" v-if="result">
            <div class="pt-0 pb-0 pl-0 pt-3">
              <strong class="mb-0 body-2 font-weight-bold black--text pt-0 pb-0 mt-0">
                [총
                <font class="font-weight-bold"> {{ result.total_rows | numberFormat }} </font>건 - 처리
                <font class="font-weight-bold blue--text"> {{ result.processed_count | numberFormat }} </font>건 / 실패
                <font class="font-weight-bold red--text"> {{ failedCount | numberFormat }} </font>건]
              </strong>
            </div>
          </div>

          <v-card class="col-12 col-md-12 mt-2 mb-4 pt-0 pb-0" v-if="result && resultDetailList.length > 0">
            <v-data-table
              :headers="headersResultList"
              :items="resultDetailList"
              :items-per-page="20"
              :footer-props="{
                'items-per-page-options': [10, 20, 30, 40, 50],
                'items-per-page-text': '목록 노출 수 선택:',
              }"
            >
              <template slot="no-data">
                <div class="noDataProductInfos">내역이 없습니다.</div>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";
import Filters from "@/libs/authservice/filters.js";

export default {
  data() {
    return {
      dialog: false,
      excelFile: null,
      uploading: false,
      result: null,
      headersResultList: [
        { text: "행 번호", align: "center", value: "row", sortable: false, width: 120 },
        { text: "사유", align: "center", value: "reason", sortable: false },
      ],
    };
  },
  mixins: [CommonMixin],
  filters: Filters,
  computed: {
    failedCount() {
      if (!this.result) {
        return 0;
      }
      return (this.result.skipped_count || 0) + (this.result.error_count || 0);
    },
    resultDetailList() {
      if (!this.result) {
        return [];
      }
      const skipped = this.result.skipped || [];
      const errors = this.result.errors || [];
      // 실패로 통합 표시 (구분 컬럼 제거). 행 번호 오름차순 정렬로 사용자가 엑셀에서 위치 찾기 쉽게.
      return [...skipped, ...errors].sort((a, b) => (a.row || 0) - (b.row || 0));
    },
  },
  methods: {
    open() {
      this.reset();
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    reset() {
      this.excelFile = null;
      this.result = null;
      this.uploading = false;
    },
    async execExcelUpload() {
      if (!this.excelFile) {
        this.alertShow("엑셀파일을 업로드해주세요.");
        return;
      }
      if (!/\.(xls|xlsx)$/i.test(this.excelFile.name)) {
        this.alertShow("엑셀 파일 형식이 올바르지 않습니다.\n(.xls / .xlsx 만 업로드 가능합니다.)");
        return;
      }
      if (this.excelFile.size > 10000000) {
        this.alertShow("엑셀파일 사이즈를 10MB 이내로 업로드해주세요.");
        return;
      }
      this.uploading = true;
      this.result = null;
      try {
        const formData = new FormData();
        formData.append("file", this.excelFile);
        const data = await M.api(M.entry("/post/notifications/external-channel-send"), formData);
        this.result = data;
        if (data && ((data.skipped_count || 0) + (data.error_count || 0) > 0)) {
          this.alertShow("엑셀 발송 처리가 완료되었습니다.\n일부 실패가 있으니 아래 결과를 확인해주세요.");
        } else {
          this.alertShow("엑셀 발송 처리가 완료되었습니다.");
        }
      } catch (e) {
        const status = e.response && e.response.status;
        const message = e.response && e.response.data && e.response.data.message;
        if (status === 400) {
          this.alertShow(message || "엑셀 파일 형식이 올바르지 않습니다.\n(.xls / .xlsx 만 업로드 가능합니다.)");
        } else if (status === 413) {
          this.alertShow("파일 용량이 너무 큽니다.\n최대 10MB 이내로 나누어 업로드해주세요.");
        } else if (status === 422) {
          const maxRows = (e.response.data && e.response.data.max_rows) || 10000;
          this.alertShow(`업로드 가능한 최대 행 수(${maxRows.toLocaleString()}개)를 초과했습니다.\n나누어 업로드해주세요.`);
        } else if (status === 404) {
          this.alertShow("아직 사용할 수 없는 기능입니다.\n잠시 후 다시 시도해주세요.");
        } else {
          this.alertShow(message || "엑셀 발송에 실패했습니다. 잠시 후 다시 시도해주세요.");
        }
      } finally {
        this.uploading = false;
      }
    },
    excelSampleDownLoad() {
      // 정적 파일 다운로드 (public/authservice/etc/sample/ 아래 배포됨)
      // 다른 excel 양식 다운로드 컴포넌트들과 동일한 패턴 유지.
      location.href = "/authservice/etc/sample/정품인증서비스_다른채널주문_메시지_발송_엑셀_양식.xlsx";
    },
  },
};
</script>

<style scoped>
.noDataProductInfos {
  padding: 50px 0;
}
</style>
